import { createSelector } from 'reselect';

import { getEntity } from 'modules/entity/selectors';
import { hasParts } from 'modules/works/selectors/advices/parts';
import { getPendingAdvices } from 'modules/works/selectors/advices';
import { hasWorks } from 'modules/works/selectors/advices/aftersales';
import {
  getMandatoryAdvices,
  hasAcceptedMandatoryAdvices,
  hasOffer,
  getNewAdvicesAnchor as getSalesAnchor
} from 'modules/works/selectors/advices/sales';

import { MODE } from 'modules/entity/constants';

import { getUI } from '.';
import { hasControlReport } from './controlReport';

const getAccept = createSelector(getUI, ui => ui.accept);
const getAcceptAndPay = createSelector(getUI, ui => ui.acceptAndPay);

export const isLoadingAccept = createSelector(getAccept, accept => accept.isLoading);
export const isLoadingAcceptAndPay = createSelector(getAcceptAndPay, acceptAndPay => acceptAndPay.isLoading);

export const isLoading = createSelector(isLoadingAccept, isLoadingAcceptAndPay, (...args) => args.some(Boolean));

export const getOfferAdvicesAccordingToAccept = createSelector(
  getPendingAdvices,
  getMandatoryAdvices,
  hasAcceptedMandatoryAdvices,
  (pendingAdvices, mandatoryAdvices, hasAccepted) => (hasAccepted ? pendingAdvices : mandatoryAdvices)
);

export const canDisplayWorksForm = createSelector(hasWorks, hasControlReport, hasOffer, hasParts, (...args) =>
  args.some(Boolean));

export const getNewAdvicesAnchor = createSelector(
  getEntity,
  getSalesAnchor,
  ({ mode }, salesAnchor) => {
    switch (mode) {
      case MODE.TECHNICIAN:
        return 'new-works';
      case MODE.PARTS:
        return 'new-parts';
      default:
        return salesAnchor;
    }
  }
);
